export default __webpack_public_path__ + "static/media/ic-feedback-management.b702424c.svg";